import { useEffect, useState } from "react";
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";
import { getPreviousMonths } from "../../../utils/Helper";

export const useAgileMatrix = () => {

    const [options, setOptions] = useState({});
    const [filterValues, setFilterValues] = useState({ months: [] });


    useEffect(() => {
        callautopopulate("issue_complexity", "issue_logitivity")?.then(res => {
            setOptions((prev) => ({ ...prev, complexity: _.sortBy(res?.issue_complexity, 'order_number'), logitivity: _.sortBy(res?.issue_logitivity, 'order_number') }))
        })
        const months = getPreviousMonths(12);
        setOptions((prev) => ({...prev, months}));
        setFilterValues((prev) => ({...prev, months: [months?.[0]]}))
    }, [])

    return { options, filterValues, setFilterValues }
}